import * as ActionsTypes from "../../../../common/constants/stateConstants";
import {objectContentElementInitialState, updateState,} from "../../../../common/utils/helpers";

const initialState = {
  facture: { ...objectContentElementInitialState },
  paiement: { ...objectContentElementInitialState },
};

/*-------------------------------------------------GET-FACTURE-SOUSCRIPTION---------------------------------------------------*/
const getFactureSouscription = (state) => {
  return updateState("facture", state, {
    ...objectContentElementInitialState,
    isLoading: true,
  });
};

const getFactureSouscriptionSuccess = (state, payload) => {
  return updateState("facture", state, {
    content: payload,
    isLoading: false,
    isSuccessed: true,
  });
};

const getFactureSouscriptionFail = (state, payload) => {
  return updateState("facture", state, {
    error: payload,
    isLoading: false,
    hasError: true,
  });
};
/*-------------------------------------------------PAIEMENT-SOUSCRIPTION----------------------------------------------------*/
const paiementSouscription = (state) => {
  return updateState("paiement", state, {
    ...objectContentElementInitialState,
    isLoading: true,
  });
};

const paiementSouscriptionSuccess = (state, payload) => {
  return updateState("paiement", state, {
    content: payload,
    isLoading: false,
    isSuccessed: true,
  });
};

const paiementSouscriptionFail = (state, payload) => {
  return updateState("paiement", state, {
    ...objectContentElementInitialState,
  });
};

const paiementSouscriptionReinitialization = (state) => {
  return updateState("paiement", state, {
    ...objectContentElementInitialState,
  });
};

/*************************************************************************** */
const paiementSouscriptionReducer = (state = initialState, action) => {
  switch (action.type) {
    /*------------------------------------------------GET-FACTURE-SOUSCRIPTION---------------------------------------------------*/
    case ActionsTypes.GET_FACTURE_SOUSCRIPTION:
      return getFactureSouscription(state, action);
    case ActionsTypes.GET_FACTURE_SOUSCRIPTION_SUCCESS:
      return getFactureSouscriptionSuccess(state, action.payload);
    case ActionsTypes.GET_FACTURE_SOUSCRIPTION_FAIL:
      return getFactureSouscriptionFail(state, action.payload);
    /*------------------------------------------------PAIEMENT-SOUSCRIPTION---------------------------------------------------*/
    case ActionsTypes.PAIEMENT_SOUSCRIPTION:
      return paiementSouscription(state, action);
    case ActionsTypes.PAIEMENT_SOUSCRIPTION_SUCCESS:
      return paiementSouscriptionSuccess(state, action.payload);
    case ActionsTypes.PAIEMENT_SOUSCRIPTION_FAIL:
      return paiementSouscriptionFail(state, action.payload);
    case ActionsTypes.PAIEMENT_SOUSCRIPTION_REINITIALIZATION:
      return paiementSouscriptionReinitialization(state);
    default:
      return state;
  }
};

export default paiementSouscriptionReducer;
